import { useState } from "react";
import logoSrc from "../../static/logo.svg";
import iconMenu from "../../static/icon-menu.svg";
import iconCloseMenu from "../../static/icon-menu-close.svg";
import logoInstagram from "../../static/logo-instagram.svg";
import logoLinkedin from "../../static/logo-linkedin.svg";
import "./Header.scss";

function Header() {
    const [opened, setOpened] = useState(false);
    const [background, setBackground] = useState(false);

    window.addEventListener("scroll", () => {
        if (window.pageYOffset > 60) {
            setBackground(true)
        } else {
            setBackground(false)
        }
    })

    function openMenu() {
        setOpened(!opened)

        if (window.innerWidth < 991) {
            setOpened(!opened)
        }
    }

    return(
        <header className={background ? "header background" : "header"}>
            <div className="container">
                <div className="header__wrapper">
                    <div className="header__wrapper__logo">
                        <img src={logoSrc} alt="Logo da Encode Bytes" />
                    </div>

                    <ul className={opened ? "header__wrapper__menu opened" : "header__wrapper__menu"}>
                        <div className="header__wrapper__menu__socials">
                            <li className="header__wrapper__menu__social">
                                <a href="https://www.linkedin.com/company/encode-bytes/" title="LinkedIn Encode Bytes" target="_blank" rel="noopener noreferrer">
                                    <img src={logoLinkedin} alt="Logo LinkedIn" />
                                </a>
                            </li>
                            <li className="header__wrapper__menu__social">
                                <a href="https://www.instagram.com/encodebytes" title="Instagram Encode Bytes" target="_blank" rel="noopener noreferrer">
                                    <img src={logoInstagram} alt="Logo Instagram" />
                                </a>
                            </li>
                        </div>
                        <li className="header__wrapper__menu__item">
                            <a href="#servicos" title="Especialidades" onClick={() => openMenu()}>Especialidades</a>
                        </li>
                        <li className="header__wrapper__menu__item">
                            <a href="#portfolio" title="Portfólio">Portfólio</a>
                        </li>
                        <li className="header__wrapper__menu__item">
                            <a href="#contato" title="Contato" onClick={() => openMenu()}>Contato</a>
                        </li>
                    </ul>

                    <button id="menuButton" className="header__wrapper__menu-button" onClick={() => openMenu()}>
                        <img src={iconMenu} className={opened ? "header__wrapper__menu-button__open hidden" : "header__wrapper__menu-button__open"} alt="Ícone do menu" />
                        <img src={iconCloseMenu} className={opened ? "header__wrapper__menu-button__close" : "header__wrapper__menu-button__close hidden"} alt="Ícone para fechar o menu" />
                    </button>
                </div>
            </div>
        </header>
    )
}

export default Header;